import React from "react";

const en_default_by_merchant = {
  //WelcomeBack messages:
  PROPOSAL_DETAILS: "Proposal sent to $v1 for an amount of $v2€",
  PROPOSAL_DETAILS_WITHOUT_AMOUNT: "Proposal sent to $v1",

  //Welcome
  INVITATION_MSG:
    "You are about to start the application process for your customer $v1",
  NIE_EU_PASSPORT:
    "If your customer has a European NIE without picture, we will request their passport.",
  INCOME: "Income",
  SPANISH_ACCOUNT_DETAIL:
    "The income document (payroll, pension, or others) and your customer's bank account ownsership certificate must be uploaded to the application",
  YOUR_LOAN_PROCESS:
    "This is how the application process to finance your customer will work",
  LOAN_ADJUSTMENT_AND_EVALUATION: "Evaluation of your customer's application",

  //KYC Manual:
  DOCUMENT_TYPE: "Your customer's document type",
  NAME_SURNAME: "Your customer's name and surname",
  BIRTH_DATA: "Your customer's birth information",
  IMAGE_ID: "Image of your customer's document",

  //Additional Data
  IMAGE_ID_NIE_EU: "Image of your customer's passport",
  CURRENT_RESIDENCE_ADDRESS: "Your customer's current address",
  ADDRESS_DIALOG_TITLE: "Your customer's current address",
  HOME_INFO: "Your customer's current home information",
  MY_CURRENT_ADDRESS_IS: "Your customer's current address is",
  YOUR_PART: "(customer's proportional part)",
  FAMILY_SITUATION: "Your customer's family situation",
  OWNERSHIP: "Owned by them",

  //Declared Income:
  PROVIDE_MAIN_INCOME_SOURCE: "Introduce your customer's main source of income",
  DIRECT_DEBIT_ACCOUNT: "Your customer's bank direct debit account",
  BANK_ACCOUNT_IBAN: "Your customer's bank account IBAN",

  //Professional Data:
  EMPLOYMENT_STATUS: "Your customer's employment status",
  COMPANY_INFO: "Your customer's workplace information",

  //SummaryAndAdjust:
  YOUR_LOAN_RESULT: "Your customer's process is almost complete!",
  APPLY_FOR_LOAN_BODY:
    "The application is not binding until your customer signs the contract digitally. They will receive an email with instructions to complete that step.",
  DATA_TREATMENT: "Your customer's data processing",
  //Application Info:
  LOAN_ANALYSING: (
    <span>
      <span>
        We have submitted your customer's application to our partner financial
        institutions and will respond as soon as possible. Stay tuned!
      </span>
      &nbsp;
      <p>
        <span>
          You can close this window and resume the process once your application
          is analyzed.
        </span>
        <p>You can reopen the application from the operation list screen.</p>
      </p>
    </span>
  ),
  PLEASE_WAIT_APPLICATION:
    "Please wait a moment, we are processing your customer's application. This process can take up to 1 minute.",

  //Documentation:
  DOCUMENTATION_UPLOAD:
    "Please upload the following documents for your customer",

  //Application info messages
  RESUME_LOAN_PROCESS: "Continue your customer's process where you left off.",
  THANKS_LOAN_FORM_COMPLETED_AND_PREAPPROVED:
    "Your customer's application has been pre-approved and is pending validation!",
  DOCS_PENDING_INFO:
    "Upload your customer's documentation now to get final confirmation faster!",
  SIGNATURE_PENDING_INFO: "Your customer needs to sign the contract digitally",
  SIGNATURE_PENDING_BY_MAIL_INFO_MESSAGE:
    "Your customer will need to check their email and sign from any device.",
  LOAN_HAS_BEEN_DENIED: "Your customer's request has not been approved.",
  SYSTEM_FAILURE_DETECTION:
    "Your customer's profile does not fit the risk policies of the collaborating financial entities.",
};

export default en_default_by_merchant;
